import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LayoutWithMap from 'containers/Base/LayoutWithMap.jsx';
import { getUserAssignedDepartmentList } from 'reducers/users';
import useFilters from 'containers/Base/useFilters.js';
import { detailOpenState } from 'reducers/ui';
import {
  attendanceActions,
  attendanceFilterActions,
  attendanceNameSpace,
  attendancePageActions,
  attendanceSelectors,
} from 'containers/Pages/People/Attendance';
import { filters } from 'containers/Pages/People/Attendance/filters';
import { getGlobalUsersRecord } from 'reducers/globalList';
import FormPopup from 'components/Operational/FormPopup';
import { CSV, SELECT_DOWNLOAD_TYPE } from 'utils/constants/attendanceTracking';
import { DownloadPopup } from './downloadPopUp';
const Attendances = ({
  columns,
  filtersRequired,
  details,
  loading,
  downloadable,
}) => {
  const [showForm, setShowForm] = useState(false);
  //---------------------------Selectors---------------------------
  const detailOpen = useSelector(state => detailOpenState(state));
  const attendanceListData = useSelector(state =>
    attendanceSelectors.getAttendanceListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    attendanceSelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    attendanceSelectors.getFilters(state),
  );
  const forceRefresh = useSelector(state =>
    attendanceSelectors.getForceRefresh(state),
  );
  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  const users = useSelector(state => getGlobalUsersRecord(state));
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchAttendanceList = useCallback(
    ({ filters, from }) =>
      dispatch(attendanceActions.fetchGridList({ filters, from })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  const dispatchPrintAttendanceList = useCallback(
    ({ filters, isCSV }) => {
      dispatch(
        attendancePageActions.printAttendanceList({ filters, isCSV: isCSV }),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  const fetchAttendances = from => {
    dispatchFetchAttendanceList({
      filters: localFilterValues,
      from,
    });
  };
  const onUpdate = () => {
    dispatchFetchAttendanceList({ filters: localFilterValues });
  };
  //filter user list
  const constructPersonnelList = users => {
    const userList = [];
    Object.entries(users).forEach(([key, value]) => {
      userList.push({
        id: key,
        name: value,
      });
    });
    return userList;
  };
  //downloads
  const onDownload = downloadType => {
    dispatchPrintAttendanceList({
      filters: localFilterValues,
      isCSV: downloadType === CSV,
    });
    setShowForm(false);
  };

  const onDownloadClick = () => {
    setShowForm(true);
  };
  const closeForm = async () => {
    setShowForm(false);
  };
  return (
    <>
      {' '}
      <LayoutWithMap
        header="Attendance Tracking"
        loading={loading}
        //data
        cols={columns}
        onUpdate={onUpdate}
        fetchData={fetchAttendances}
        data={attendanceListData}
        totalEntries={totalEntries}
        forceRefresh={forceRefresh}
        //end data
        //details
        DetailComponent={details}
        forceOpenDetailPanel={detailOpen[attendanceNameSpace]}
        //creating and editing
        editable={false}
        //filters
        filtersRequired={filtersRequired}
        filterValues={localFilterValues}
        filters={filters(
          constructPersonnelList(users),
          userAssignedDepartments,
        )}
        setFilters={(values, hasApplyFilter) =>
          updateFilter({
            values,
            hasApplyFilter,
            applyFilter: filters => {
              attendanceFilterActions.setFilterKey({ key: true });
              attendanceFilterActions.setFilters({ filters });
            },
          })
        }
        //end-filters
        //Downloads
        downloadable={downloadable}
        onDownloadClick={onDownloadClick}
        downloadHoverText={'Download Attendance Tracking PDF report'}
        //end downloads
      />
      {showForm && (
        <FormPopup
          headerTitle={SELECT_DOWNLOAD_TYPE}
          closePopup={closeForm}
          form={<DownloadPopup submit={onDownload} />}
        />
      )}
    </>
  );
};
Attendances.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  downloadable: PropTypes.bool,
};
export default Attendances;
